export const webEmbedTab = {
  scope: {
    title: "Que doit rechercher votre site ?",
    only: "Uniquement",
    thisListing: "cette annonce",
    hint: "Recommandé si vous collez le code sur la page de cet hébergement. Désactivez-le pour que la recherche affiche tous vos hébergements.",
  },
  where: {
    title: "Où les hébergements doivent-ils apparaître ?",
    hint: 'La barre de recherche est identique dans les trois cas. Ce qui change, c\'est ce qui se passe lorsque le visiteur appuie sur « Rechercher ».',
    ariaLabel: "Où la disponibilité apparaît",
    ownFields: {
      name: "J'ai déjà ma propre barre de recherche",
      hint: "Nous n'ajouterons pas notre barre : utilisez vos propres champs et transmettez-nous la recherche",
    },
  },
  modes: {
    overlay: {
      name: "Flottant au-dessus de votre site",
      tag: "Recommandé",
      desc: "La liste s'ouvre dans une fenêtre au-dessus de votre page et se ferme avec le X. Votre site ne bouge pas : le visiteur revient exactement là où il était.",
    },
    inline: {
      name: "À l'intérieur de votre page",
      desc: "La liste apparaît sur votre propre site, comme une section supplémentaire : elle défile avec le reste du contenu et il n'y a rien à fermer. Vous choisissez où elle s'affiche sur la page.",
    },
    tab: {
      name: "Dans un nouvel onglet",
      desc: "La barre reste sur votre site et, lors de la recherche, la réservation se poursuit dans un autre onglet. C'est l'option la plus simple, mais le visiteur poursuit la réservation ailleurs.",
    },
  },
  modeNote: {
    overlay: "La barre de recherche conserve une hauteur fixe et ne change pas : la liste et tout le processus de réservation se déroulent dans la fenêtre flottante, avec son propre défilement.",
    inline: "Ici, la seule chose qui s'agrandit est la section de la liste, ce qui correspond exactement à ce que vous avez demandé. La barre de recherche occupe toujours le même espace et le calendrier s'ouvre au-dessus d'elle, sans rien décaler.",
    tab: "Seule la barre est intégrée. Tout le reste se déroule dans le moteur de réservation, dans un onglet séparé.",
  },
  webs: {
    bahia: "Site avec un hero",
    cala: "Site minimaliste",
  },
  fondos: {
    white: "Blanc (par défaut)",
    transparent: "Transparent · adopte celui de votre site",
  },
  appearance: {
    title: "Apparence",
    buttonColor: "Couleur du bouton",
    background: "Fond de la barre de recherche",
    language: "Langue",
  },
  preview: {
    title: "Rendu sur un site web",
    hint: "Un site d'exemple avec votre barre de recherche en place. C'est le vrai widget : choisissez des dates et appuyez sur Rechercher pour voir son comportement.",
    openFull: "Ouvrir en taille réelle",
    testIn: "Tester sur",
    testInAriaLabel: "Site web d'exemple",
    missingUuid: "L'identifiant du compte est manquant pour générer le widget.",
    fakeUrl: "your-site.com",
    iframeTitle: "Aperçu du widget sur un site web d'exemple",
  },
  guide: {
    title: "Comment l'ajouter à votre site",
    hint: 'Fonctionne sur n\'importe quelle page : HTML, WordPress (bloc « HTML personnalisé »), Wix, Squarespace, Shopify… Rien à installer.',
    warn: "<b>Si votre site est sous Wix, Squarespace ou Shopify</b>, deux choses : dans l'<b>éditeur</b>, le bloc de code semble toujours vide — il ne fonctionne qu'en « Aperçu » ou une fois publié —, et comme ces plateformes encadrent la barre de recherche dans un cadre qui leur est propre, <b>tout se passe à l'intérieur de ce cadre</b> : le calendrier et la liste des hébergements. Donc <b>étirez-le à environ 900 px de haut</b> dans l'éditeur ; s'il est trop court, le calendrier est coupé. Nous nous occupons du reste : ne modifiez pas le code.",
    missingUuid: "L'identifiant du compte est manquant pour générer le code.",
    copy: "Copier",
    copied: "Copié",
    saveReload: "Enregistrez et rechargez votre site",
  },
  steps: {
    script: {
      title: "Collez ceci à l'endroit où vous souhaitez que la barre de recherche apparaisse",
      titleOwn: "Collez ceci une seule fois, n'importe où sur la page",
      hint: "Juste là où vous voulez la barre de dates : le hero, un bandeau sous le menu, une barre latérale…",
      hintOwn: "Il n'affiche rien par lui-même : il prépare la réservation pour votre propre formulaire.",
      after: "La barre conserve une hauteur fixe et ne se redimensionne pas, elle ne perturbera donc pas votre mise en page.",
    },
    target: {
      title: "Collez cet emplacement là où vous souhaitez que la liste apparaisse",
      hint: 'Généralement une section à part sous le hero, avec votre titre au-dessus (« Disponibilité », « Nos logements »…).',
      after: "Tant que personne ne recherche, cet emplacement n'occupe aucun espace. Si vous l'omettez, la liste apparaît juste sous la barre de recherche.",
    },
    api: {
      title: "Connectez vos champs à la recherche",
      hint: "Vous conservez votre design, mais le calendrier peut être le nôtre : celui qui affiche le prix de chaque nuit, le séjour minimum et les jours réservés.",
      after: "Si vous préférez vos propres champs de dates, cela fonctionne aussi : transmettez-nous les dates au format YYYY-MM-DD directement à WACheckin.search().",
    },
  },
  toasts: {
    manualCopySummary: "Copie manuelle",
    manualCopyDetail: "Votre navigateur n'a pas autorisé la copie automatique. Le code est déjà sélectionné.",
  },
};
